import { Link } from "react-router-dom";
import { PageHero, SectionHeading, Reveal } from "@/components/Section";
import { IMAGES } from "@/data/site";
import { Check, ArrowRight } from "lucide-react";

const PROJECTS = [
  { img: IMAGES.renoKitchen, t: "KITCHEN RENOVATION — IN PROGRESS" },
  { img: IMAGES.renoBath, t: "BATHROOM TILING" },
  { img: IMAGES.renoFoundation, t: "FOUNDATION POUR" },
  { img: IMAGES.renoCommercial, t: "COMMERCIAL FIT-OUT" },
  { img: IMAGES.renoRoof, t: "ROOF TRUSSES UP" },
  { img: IMAGES.renoExterior, t: "BRICK WALLS RISING" },
];
const SERVICES = [
  ["FULL HOUSE RENOVATIONS","Kitchens, bathrooms, structural changes, extensions — managed from plans to handover."],
  ["NEW HOME CONSTRUCTION","We build new residential properties from the ground up. Plans, foundation, structure, finishes."],
  ["COMMERCIAL FIT-OUTS","Office renovations, retail fit-outs, warehouses and commercial construction projects."],
  ["STRUCTURAL & EXTENSIONS","Room additions, second floors, garage conversions, structural alterations."],
  ["TILING, PLASTER & FINISHES","Full interior finishing — floor tiles, wall tiles, plastering, cornices, skirtings."],
  ["ROOFING & WATERPROOFING","Roof installations, replacements, leak repairs and full waterproofing solutions."],
];
const EDGE_POINTS = [
  "No materials markup — we supply at our own cost",
  "No waiting on deliveries — we have the stock",
  "No blaming the supplier — one team, full accountability",
  "Faster completion — materials are always ready",
];
const PROJECT_STEPS = [
  ["01","Tell us about your project (location, scope, timeline)"],
  ["02","We visit the site and prepare a detailed quotation"],
  ["03","You approve and we mobilise the team"],
  ["04","We complete with regular progress updates"],
  ["05","Final inspection and handover"],
];

const AdvantageBanner = () => (
  <section className="bg-[#E8721C] py-12">
    <div className="max-w-[1400px] mx-auto px-5 lg:px-10">
      <p className="font-display text-[26px] md:text-[36px] text-[#0A1628] leading-[1.1]">
        MOST CONTRACTORS BUY MATERIALS FROM US. WE BUILD WITH THEM OURSELVES. <span className="underline decoration-[#0A1628]/40">THAT'S YOUR ADVANTAGE.</span>
      </p>
    </div>
  </section>
);

const WhatWeBuildSection = () => (
  <section className="bg-[#F8F6F2] py-24">
    <div className="max-w-[1400px] mx-auto px-5 lg:px-10">
      <SectionHeading label="WHAT WE BUILD" title="END-TO-END CONSTRUCTION SERVICES." />
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {SERVICES.map(([t,d],i) => (
          <Reveal key={t} delay={i*70}><div className="cg-card h-full"><h4 className="font-display text-[22px] heading-bar">{t}</h4><p className="mt-3 text-[#1E2D40] leading-7">{d}</p></div></Reveal>
        ))}
      </div>
    </div>
  </section>
);

const OurEdgeSection = () => (
  <section className="bg-[#0A1628] text-white py-24 blueprint-grid">
    <div className="max-w-[1400px] mx-auto px-5 lg:px-10 grid lg:grid-cols-12 gap-10 items-start">
      <div className="lg:col-span-6">
        <SectionHeading light label="OUR EDGE" title="WE ARE THE SUPPLIER AND THE CONTRACTOR." />
        <ul className="space-y-3 text-[#cbd3df] text-[17px]">
          {EDGE_POINTS.map((t) => <li key={t} className="flex gap-3"><Check size={20} className="text-[#E8721C] shrink-0 mt-1"/>{t}</li>)}
        </ul>
        <Link to="/contact?type=renovation" className="btn-orange mt-8">Request a Free Consultation <ArrowRight size={14}/></Link>
      </div>
      <div className="lg:col-span-6 grid grid-cols-2 gap-3">
        {PROJECTS.map((p,i) => (
          <Reveal key={p.t} delay={i*70}>
            <div className="relative h-40 md:h-44 overflow-hidden group">
              <img src={p.img} alt={p.t} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"/>
              <div className="absolute inset-0 bg-gradient-to-t from-[#0A1628]/90 via-transparent to-transparent"/>
              <div className="absolute bottom-3 left-3 right-3 font-display text-[13px] tracking-wider text-white">{p.t}</div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

const HowToStartSection = () => (
  <section className="bg-[#F8F6F2] py-24">
    <div className="max-w-[1400px] mx-auto px-5 lg:px-10">
      <SectionHeading title="HOW TO START A PROJECT" />
      <div className="grid md:grid-cols-5 gap-4">
        {PROJECT_STEPS.map(([n,t]) => (
          <div key={n} className="cg-card h-full"><div className="font-display text-[36px] text-[#E8721C]">{n}</div><p className="mt-2 text-[#1E2D40] text-[14px] leading-6">{t}</p></div>
        ))}
      </div>
    </div>
  </section>
);

const Renovation = () => (
  <>
    <PageHero
      label="RENOVATION & CONSTRUCTION DIVISION"
      title="WE DON'T JUST SUPPLY THE MATERIALS. WE BUILD THE BUILDING."
      subtitle="Full house renovations, new construction and commercial builds — managed end to end. And because we supply our own materials, your project costs less."
      image={IMAGES.renoExterior}
    />
    <AdvantageBanner />
    <WhatWeBuildSection />
    <OurEdgeSection />
    <HowToStartSection />
  </>
);
export default Renovation;
